import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './common/login/login.component';
import { MyProfileComponent } from './common/my-profile/my-profile.component';
import { PreloadListDataComponent } from './common/preload-list-data/preload-list-data.component';
import { PreloadListComponent } from './common/preload-list/preload-list.component';
import { SignupComponent } from './common/signup/signup.component';
import { DashboardComponent } from './dashboard/dashboard.component';
//SSO
import { AppBoughtComponent } from './app-bought/app-bought.component';
import { AppCollaboratorListComponent } from './app-collaborator-list/app-collaborator-list.component';
import { AppRoleListComponent } from './app-role-list/app-role-list.component';
import { AppRoleUsecaseListComponent } from './app-role-usecase-list/app-role-usecase-list.component';
import { AppStatusComponent } from './app-status/app-status.component';
import { AppStoreComponent } from './app-store/app-store.component';
import { AppUsecaseComponent } from './app-usecase/app-usecase.component';
import { ApplicationApiComponent } from './application-api/application-api.component';
import { ApplicationListComponent } from './application-list/application-list.component';
import { ApplicationUsersComponent } from './application-users/application-users.component';
import { AttributesListComponent } from './attributes-list/attributes-list.component';
import { CustomApisComponent } from './components/custom-apis/custom-apis.component';
import { DashboardsComponent } from './components/dashboards/dashboards.component';
import { SignupInvitationComponent } from './components/signup-invitation/signup-invitation.component';
import { UiformBaseComponent } from './components/uiform/uiform-base/uiform-base.component';
import { UiformEditComponent } from './components/uiform/uiform-edit/uiform-edit.component';
import { UiformGraphComponent } from './components/uiform/uiform-graph/uiform-graph.component';
import { UiformListComponent } from './components/uiform/uiform-list/uiform-list.component';
import { UiformPivotComponent } from './components/uiform/uiform-pivot/uiform-pivot.component';
import { InvitationDeveloperComponent } from './invitation-developer/invitation-developer.component';
import { MenuEditorComponent } from './menu-editor/menu-editor.component';
import { OrganizationListComponent } from './organization-list/organization-list.component';
import { OrganizationComponent } from './organization/organization.component';
import { ReportsListComponent } from './reports-list/reports-list.component';
import { RoleListComponent } from './role-list/role-list.component';
import { RulesListComponent } from './rules-list/rules-list.component';
import { TableRowEditorComponent } from './table-row-editor/table-row-editor.component';
import { TasksListComponent } from './tasks-list/tasks-list.component';
import { TeamComponent } from './team/team.component';
import { UiAllformListComponent } from './ui-allform-list/ui-allform-list.component';
import { UiformCreateComponent } from './uiform-create/uiform-create.component';
import { UiformEntryComponent } from './uiform-entry/uiform-entry.component';
import { UsecaseDataComponent } from './usecase-data/usecase-data.component';
import { UserListComponent } from './user-list/user-list.component';
import { UsersComponent } from './users/users.component';
import { MigrationsListComponent } from './components/migrations-list/migrations-list.component';
import { MenuListComponent } from './menu-list/menu-list.component';
import { SupportTicketComponent } from './support-ticket/support-ticket.component';
import { SupportTicketListComponent } from './support-ticket-list/support-ticket-list.component';
import { ForgotPasswordComponent } from './common/forgot-password/forgot-password.component';
import { UsecaseDatabaseComponent } from './usecase-database/usecase-database.component';
import { PublicFormComponentComponent } from './public-form-component/public-form-component.component';
import { ApplicationInfoComponent } from './application-info/application-info.component';
import { ApplicationConfigurationComponent } from './application-configuration/application-configuration.component';
import { EmailConfigurationComponent } from './email-configuration/email-configuration.component';
import {EmailTemplateComponent} from './email-template/email-template.component';
import { JasperComponent } from './components/uiform/jasper/jasper.component';
import { TestEmailComponent } from './test-email/test-email.component';
import { AssetReportComponent } from './asset-report/asset-report.component';

import { AiReportComponent } from './components/uiform/ai-report/ai-report.component';
import { TaskBoardComponent } from './components/uiform/task-board/task-board.component';
import { PaymentGatewayConfigComponent } from './payment-gateway-config/payment-gateway-config.component';
import { TestPaymentGatewayComponent } from './test-payment-gateway/test-payment-gateway.component';
import { UploadLogsComponent } from './upload-logs/upload-logs.component';


const routes: Routes = [
  {
    path: 'invitedeveloper/:token',
    component: InvitationDeveloperComponent,
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'login/:param',
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    component: DashboardsComponent,
  },
  {
    path: 'appsdashboard',
    component: DashboardComponent,
  },
  {
    path: 'signup',
    component: SignupComponent,
  },
  {
    path: 'myprofile',
    component: MyProfileComponent,
  },
  {
    path: 'preloadlist',
    component: PreloadListComponent,
  },
  {
    path: 'preloadlistdatalist',
    component: PreloadListDataComponent,
  },
  {
    path: 'preloadlistdatalist/:id',
    component: PreloadListDataComponent,
  },
  {
    path: 'users',
    component: UsersComponent,
  },

  // CuickDev
  {
    path: 'orglist',
    component: OrganizationListComponent,
  },
  {
    path: 'organization',
    component: OrganizationComponent,
  },
  {
    path: 'applicationlist',
    component: ApplicationListComponent,
  },
  {
    path: 'userlist',
    component: UserListComponent,
  },
  {
    path: 'rolelist',
    component: RoleListComponent,
  },
  {
    path: 'rolelist/:appId',
    component: RoleListComponent,
  },
  {
    path: 'usecase/:appId',
    component: AppUsecaseComponent,
  },
  {
    path: 'usecasedata/:usecaseId',
    component: UsecaseDataComponent,
  },
  {
    path: 'api/:appId',
    component: ApplicationApiComponent,
  },
  {
    path: 'attribute/:appId/:usecaseId',
    component: AttributesListComponent,
  },
  {
    path: 'attribute/:appId',
    component: AttributesListComponent,
  },

  {
    path: 'appuser/:appId',
    component: ApplicationUsersComponent,
  },
  {
    path: 'usecaseuiform/:appId/:usecaseId/:uiformId',
    component: UiformEntryComponent,
  },

  {
    path: 'uiform/:uiformId',
    component: UiformEditComponent,
  },

  {
    path: 'uiform/:uiformId/:id',
    component: UiformEditComponent,
  },
  {
    path: 'uiformlist/:uiformId',
    component: UiformListComponent,
  },
  {
    path: 'uiallformlist',
    component: UiAllformListComponent,
  },
  {
    path: 'uiallformlist/:id',
    component: UiAllformListComponent,
  },
  {
    path: 'uiformchart/:uiformId',
    component: UiformGraphComponent,
  },

  {
    path: 'uiformchartcustom/:formId',
    component: UiformGraphComponent,
  },
  {
    path: 'uiformpivot/:uiformId',
    component: UiformPivotComponent,
  },
  {
    path: 'uiformpivot/:uiformId/:reportId',
    component: UiformPivotComponent,
  },
  {
    path: 'menus/:appId',
    component: MenuEditorComponent,
  },
  {
    path: 'menuslist',
    component: MenuListComponent,
  },
  {
    path: 'menuslist/:appId',
    component: MenuListComponent,
  },
  {
    path: 'migration/:appId',
    component: MigrationsListComponent,
  },
  {
    path: 'team',
    component: TeamComponent,
  },
  {
    path: 'appstore',
    component: AppStoreComponent,
  },
  {
    path: 'appstatus',
    component: AppStatusComponent,
  },
  {
    path: 'appbought',
    component: AppBoughtComponent,
  },
  {
    path: 'uiformcreate/:usecaseId',
    component: UiformCreateComponent,
  },
  {
    path: 'appcollaboratorlist',
    component: AppCollaboratorListComponent,
  },
  {
    path: 'appcollaboratorlist/:appId',
    component: AppCollaboratorListComponent,
  },
  {
    path: 'approle',
    component: AppRoleListComponent,
  },
  {
    path: 'approle/:appId',
    component: AppRoleListComponent,
  },
  {
    path: 'approleusecase',
    component: AppRoleUsecaseListComponent,
  },
  {
    path: 'roleditor',
    component: TableRowEditorComponent,
  },
  {
    path: 'rules',
    component: RulesListComponent,
  },
  {
    path: 'rules/:appId',
    component: RulesListComponent,
  },
  {
    path: 'customapis/:usecaseId',
    component: CustomApisComponent,
  },
  {
    path: 'uiforminfo/:uiformId',
    component: UiformBaseComponent,
  },
  {
    path: 'taskslist',
    component: TasksListComponent,
  },
  {
    path: 'reportslist',
    component: ReportsListComponent,
  },
  {
    path: 'reportslist/:id',
    component: ReportsListComponent,
  },
  {
    path: 'reportslist/:id/:reportid',
    component: ReportsListComponent
  },
  {
    path: 'signupInvitation',
    component: SignupInvitationComponent,
  },
  {
    path: 'supportticket',
    component: SupportTicketComponent,
  },
  {
    path: 'supportticket/:id',
    component: SupportTicketComponent,
  },
  {
    path: 'supportticketlist',
    component: SupportTicketListComponent,
  },
   {
    path: 'forgot-password', 
    component: ForgotPasswordComponent, 
  },
  {
    path: 'usecaseDatabase/:appId',
    component: UsecaseDatabaseComponent,
  },
  {
    path: 'form/:id',
    component: PublicFormComponentComponent,
  },
{
    path: 'applicationUser/:id',
    component: ApplicationUsersComponent,
  },
  {
    path: 'applicationInfo/:id',
    component: ApplicationInfoComponent,
  },
  {
    path: 'applicationConfiguration/:appId',
    component: ApplicationConfigurationComponent,
  },
  {
    path: 'emailconfiguration/:appId',
    component: EmailConfigurationComponent,
  },
  {
    path: 'emailtemplate/:appId',
    component: EmailTemplateComponent,
  },
     {
    path: 'jasper/:id',
    component: JasperComponent,
  },
  {
    path: 'aireport/:id',
    component: AiReportComponent,
  },
  {
    path: 'taskboard/:id',
    component: TaskBoardComponent,
  },
  {
    path: 'testemail/:appId',
    component: TestEmailComponent,
  },
  {
    path: 'assetReport',
    component: AssetReportComponent,
  },
  {
    path: 'testemail/:appId',
    component: TestEmailComponent,
  },
  {
    path: 'paymentconfiguration/:appId',
    component: PaymentGatewayConfigComponent,
  },
  {
    path: 'paymentconfiguration/:appId/:id',
    component: PaymentGatewayConfigComponent,
  },
  {
    path: 'testpayemtdateway/:appId',
    component: TestPaymentGatewayComponent,
  },
   {
    path: 'upload-logs/:usecaseId',
    component: UploadLogsComponent
  },
   {
  path: 'upload-logs/:usecaseId/:uploadId',
  component: UploadLogsComponent
}
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
